<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <p class="subheading-serif">Diamond Mills Room Block</p>
          <button type="button" class="btn-close" @click="close">&times;</button>
        </header>

        <section class="modal-body">
          <p class="body-lg">The following room types are available with our room block at <a href="https://www.diamondmillshotel.com/" target="_blank" rel="noopener noreferrer">Diamond Mills</a>:</p>

          <table>
            <tr>
              <th class="body-md body-md--medium">Room type</th>
              <th class="body-md body-md--medium">Beds per room</th>
              <th class="body-md body-md--medium">Cost per night</th>
            </tr>
            <tr>
              <td class="body-md body-md--light">Deluxe King</td>
              <td class="body-md body-md--light">1</td>
              <td class="body-md body-md--light">$349</td>
            </tr>
            <tr>
              <td class="body-md body-md--light">Deluxe Queen</td>
              <td class="body-md body-md--light">2</td>
              <td class="body-md body-md--light">$359</td>
            </tr>
            <tr>
              <td class="body-md body-md--light">Supreme King</td>
              <td class="body-md body-md--light">1</td>
              <td class="body-md body-md--light">$379</td>
            </tr>
            <tr>
              <td class="body-md body-md--light">Supreme Queen</td>
              <td class="body-md body-md--light">2</td>
              <td class="body-md body-md--light">$379</td>
            </tr>
          </table>

          <p class="body-lg">To receive the discounted rate listed above, reservations must be booked over the phone at (845) 247-0700 and reference “Bae-McCarthy Wedding Room Block”.</p><p class="body-lg">Bookings require a 2-night minimum and a 50% non-refundable deposit.</p>
         </section>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Modal',
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000 !important;
  }

  .modal {
    background: $color-neutral-100;
    box-shadow: 0px 10px 84px -3px rgba(0,0,0,0.1);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 100001 !important;

    @include min-width(tablet) {
      max-width: 650px;
    }
  }

  .modal-header {
    padding: $space-2 $space-3;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: $border-900-sm;
    justify-content: space-between;
  }

  .modal-body {
    position: relative;
    padding: $space-3;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 32px;
    padding: $space-2 $space-3;
    cursor: pointer;
    color: $color-shade-900;
    background: transparent;
  }

  table {
    border-collapse: collapse;
    margin: $space-4 0;
  }

  tr:nth-child(2),
  tr:nth-child(4),
  tr:nth-child(5) {
    text-decoration: line-through;

    td:nth-child(3) {
      position: relative;

      &::after {
        align-items: center;
        background-color: #484848;
        color: $color-shade-100;
        content: 'FULLY BOOKED';
        display: flex;
        font-size: 13px;
        height: 100%;
        left: 0;
        padding-left: $space-1;
        position: absolute;
        top: 0;
        width: -webkit-fill-available;
      }
    }
  }

  td, th {
    border: $border-900-sm;
    margin: 0;
    padding: $space-1;
  }

  th {
    text-align: left;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>